
/* global google */
import { CircularProgress } from "@mui/material";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import { memo, useState } from "react";
//   import "./App.css";

const MapComponent = ({ markers = [], center }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });
  const [mapRef, setMapRef] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [infoWindowData, setInfoWindowData] = useState();

  // const markers = [
  //   { address: "Address1", lat: 18.5204, lng: 73.8567 },
  //   { address: "Address2", lat: 18.5314, lng: 73.8446 },
  //   { address: "Address3", lat: 18.5642, lng: 73.7769 },
  // ];

  const onMapLoad = (map) => {
    setMapRef(map);
    const bounds = new google.maps.LatLngBounds();
    markers?.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    map.fitBounds(bounds);
  };

  const handleMarkerClick = (id, lat, lng, address) => {
    mapRef?.panTo({ lat, lng });
    setInfoWindowData({ id, address });
    setIsOpen(true);
  };
  
  return (
    <>
      {!isLoaded ? (
        <CircularProgress />
      ) : (
        <GoogleMap
          mapContainerStyle={{ height: "100%", width: "100%" }}
          mapContainerClassName="map-container"
          options={{
            fullscreenControl: true,
            zoomControl: false,
            mapTypeControl: false,

          }}
          center={center ?? {
            lat: markers?.[0]?.lat ?? 22.995275,
            lng: markers?.[0]?.lng ?? 72.662987,

          }}
          zoom={10}
          onLoad={onMapLoad}
          onClick={() => setIsOpen(false)}
        >
          {markers.map(({ address, lat, lng }, ind) => (
            <Marker
              key={ind}
              position={{ lat, lng }}
              onClick={() => {
                handleMarkerClick(ind, lat, lng, address);
              }}
            >
              {isOpen && infoWindowData?.id === ind && (
                <InfoWindow
                  onCloseClick={() => {
                    setIsOpen(false);
                  }}
                >
                  <h3>{infoWindowData.address}</h3>
                </InfoWindow>
              )}
            </Marker>
          ))}
        </GoogleMap>
      )}
    </>
  );
};

export default memo(MapComponent);
